import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { GlobalserviceService } from '../globalservice.service';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatSliderModule, DateAdapter} from '@angular/material';





@Component({
  selector: 'app-oduser',
  templateUrl: './oduser.component.html',
  styleUrls: ['./oduser.component.css']
})
export class ODuserComponent implements OnInit {
  locations: any;
  Location: any;
  method(arg0: any): any {
    throw new Error("Method not implemented.");
  }
  Range = false;
  currentOD = []; ODcount = [];
  range: boolean; device: number; ODtoatl; allData: any; data: any; location: any; from: any; From: any;
  to: any;
  To: any;
  type: any; dat;
  filterdat: any;
  countall: any;
  filterdats: any; Userdata = '';
  control = new FormControl('1');
  allfilter = [];
  selectedperiod;
  todaydat: any[];
  ODtrue: boolean;
  ODfalse: boolean;
  Locationone: any; locationSingel;
  LocationMulti: boolean; mainCard;
  signinloca: string; siginlocat; adminOne;
  locationOD: any; adminmulti; adminCard;

  sessData: any;
  minDate: Date;
  maxDate: Date;

  today;
  date_today;fromdate;tomindate;fromdateonly;date_todayonly;
  datedata;

  finalfromdate;finaltodate;fromdatelastfilter;todatelastfilter;

  constructor(private router: Router, route: ActivatedRoute, public snackBar: MatSnackBar, public globalservice: GlobalserviceService, ) { }
//
  ngOnInit() {

   this.today = new Date();
   this.date_todayonly  = this.today.getDate() < 10 ? '0' + this.today.getDate() : this.today.getDate();
 this.date_today = this.today.getFullYear()+'-'+(this.today.getMonth()+1)+'-'+ this.date_todayonly;

 //this.date_today = this.today.getDate()+'-'+(this.today.getMonth()+1)+'-'+this.today.getFullYear()

console.log(this.date_today );

    var ses_location = sessionStorage.getItem("filterloc");

    this.filterRedirect(ses_location);

    this.Total_OD();
    this.all_LocationFn();
    this.onelocation();
    this.selectedperiod = '1';
    this.onChange(this.selectedperiod);
    this.signinloca = this.signinloca;
    this.onChange_singel(this.signinloca);
    this.loadin_pade();

    //
    // this.all_LocationFn();
    this.Location = sessionStorage.filterloc;
    this.sessData = sessionStorage.getItem("filterloc");

    this.location = sessionStorage.filterloc;
 //   console.log(sessionStorage.filterloc); debugger;
    //
  }

  fromdateFilter(fromdate){
    // console.log(fromdate);
    // console.log(fromdate.getDate() + '-' + (fromdate.getMonth()+1) + '-' + fromdate.getFullYear());

    //fromdate.getDate();

    if(fromdate.getDate() < 10){
        this.fromdateonly = '0'+ fromdate.getDate();
    }
    else{
      this.fromdateonly = fromdate.getDate();
    }

    this.tomindate = fromdate.getFullYear()+'-'+(fromdate.getMonth()+1)+'-'+ this.fromdateonly;
    console.log( this.tomindate);
  }


  table_view() {
    this.router.navigate(['dashboard/ODuser_Table']);
    var page = sessionStorage.page;
    delete sessionStorage.page;
  }
  onelocation() {
    //   signinlocation
    this.signinloca = sessionStorage.getItem('signinlocation');
    if (sessionStorage.siginType == 'a') {
      this.Locationone = true;
      this.LocationMulti = false;
      this.adminOne = true;
      this.adminmulti = false;
      this.adminCard = true;
      this.mainCard = false
      this.type;
     this.locations;
    }
    else {
      this.Locationone = false;
      this.LocationMulti = true;
      this.adminOne = false;
      this.adminmulti = true;
      this.adminCard = false;
      this.mainCard = true;
      this.type;
      this.locations;
    }

    this.filterFn();
  }

  onChange_singel(signinloca) {
    this.locations =this.signinloca;
     this.filterFn();
  }

  Total_OD() {
    this.globalservice.enableloader();
    this.globalservice.OD_total().subscribe(responsedata => {
     this.globalservice.disableloader();
      if (responsedata.Success) {
        this.ODtoatl = responsedata['Message'];
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
  onChange(data) {
    console.log(data); debugger;
    this.type = data;
    if (data == 4) {
      this.device = 4;
      this.Range = true;

    } else {
      this.device = 0;
      this.Range = false;
    }

    this.filterFn();
    this.locations;
   }
  loadin_pade(){
    if (sessionStorage.siginType == 'a') {
      this.onChange(Object);
      this.type;
      this.locations;
      this.filterFn();
    }
  }

  all_LocationFn() {
     this.globalservice.enableloader();
    this.globalservice.location().subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.allData = responsedata['Data'];
        console.log(this.allData);


     //   this.Location = this.allData[0] ;
     //   console.log(this.allData[0]);
                //

                this.sessData = sessionStorage.getItem("filterloc");
                console.log(this.sessData);
                console.log(this.allData);
                      for ( var i = 0; i < this.allData.length; i++) {
                        if (this.allData[i].location === this.sessData) {
                          this.Location = this.allData[i] ;
                   //       console.log(this.Location);debugger;
                        }
                      //  else {
                      //   this.Location = '';
                      //  }
                  }

                //
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });



  }

  onChanges(value, dataloc) {
    this.location = dataloc.location;
    sessionStorage.setItem("filterloc", this.location);
    this.type;
    this.From;
    this.to;
    this.filterFn();
  }
  filterFn() {
    if (this.location == undefined) {
      this.location = '';
    } else {
      this.location = this.location;
      var level = {
        "Location": this.location,
        "FromDate": this.From,
        "ToDate": this.to,
        "Type": this.type,
      }
      console.log(level); debugger;
    }
    if (sessionStorage.siginType == 'a') {
      if(this.type==Object){
       this.type='1'
      }
      this.locations;
      this.type;
      var level = {
        "Location": this.locations,
        "FromDate": this.From,
        "ToDate": this.to,
        "Type":  this.type,
      }
   }
    this.globalservice.enableloader();
    this.globalservice.AdminFilter(level).subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.filterdat = responsedata['Data'];
        this.dat = [];
        for (var i = 0; i < this.filterdat.length; i++) {
          this.dat.push({
            "Department": this.filterdat[i].DEPARTMENT,
            "Count": this.filterdat[i].count,
            "color": this.filterdat[i].color,
          });
        }
        this.ODtrue = true;
        this.ODfalse = false;
      }
      else {
        this.ODtrue = false;
        this.ODfalse = true;
        this.filterdat= responsedata['Message']
        // this.snackBar.open(this.filterdat ,'', { duration: 1000 });
      }

    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }

                    //
                    filterRedirect(params) {
                      if (params == undefined) {
                        this.location = '';
                      } else {
                        this.location = params;
                  //       this.Location = params;
                        var level = {
                          "Location": this.location,
                          "FromDate": this.From,
                          "ToDate": this.to,
                          "Type": this.type,
                        }
                      }
                      if (sessionStorage.siginType == 'a') {
                        if(this.type==Object){
                         this.type='1'
                        }
                        this.locations;
                        this.type;
                        var level = {
                          "Location": this.locations,
                          "FromDate": this.From,
                          "ToDate": this.to,
                          "Type":  this.type,
                        }
                     }
        //             console.log(level);debugger;
                      this.globalservice.enableloader();
                      this.globalservice.AdminFilter(level).subscribe(responsedata => {
                        this.globalservice.disableloader();
                        if (responsedata.Success) {
                          this.filterdat = responsedata['Data'];
                          this.dat = [];
                          for (var i = 0; i < this.filterdat.length; i++) {
                            this.dat.push({
                              "Department": this.filterdat[i].DEPARTMENT,
                              "Count": this.filterdat[i].count,
                              "color": this.filterdat[i].color,
                            });
                          }
                          this.ODtrue = true;
                          this.ODfalse = false;
                        }
                        else {
                          this.ODtrue = false;
                          this.ODfalse = true;
                          this.filterdat= responsedata['Message']
                          // this.snackBar.open(this.filterdat ,'', { duration: 1000 });
                        }

                      },
                        err => {
                          this.globalservice.disableloader();
                          alert("Network Error");
                        });
                    }
                    //new edit

                   //

  onChangeFilter(fromdate, todate) {
    console.log(fromdate);
    console.log(todate);
    this.fromdatelastfilter = fromdate.getDate() < 10 ? '0' + fromdate.getDate() : fromdate.getDate();
    this.todatelastfilter = todate.getDate() < 10 ? '0' + todate.getDate() : todate.getDate();

    // console.log(from); console.log(To); debugger;
   this.finalfromdate = this.fromdatelastfilter + '-' + (fromdate.getMonth()+1) + '-' + fromdate.getFullYear();
   this.finaltodate = this.todatelastfilter  + '-' + (todate.getMonth()+1) + '-' + todate.getFullYear();



    this.From = this.finalfromdate;
    this.to = this.finaltodate;
    this.location;
    this.type;
    this.filterFn();
  }
  OD_userfilter(i, datafn) {
   // console.log(datafn); debugger;
    if (this.location == undefined) {
      this.location = '';
    } else {
      this.location = this.location;
      var filt = {
        "Type": this.type,
        "Location": this.location,
        "Department": datafn[i]['Department'],
        "FromDate": this.From,
        "ToDate": this.to,
      }
    }
    if (sessionStorage.siginType == 'a') {
      this.locations;
      var level = {
        "Type": this.type,
        "Location": this.locations,
        "Department": datafn[i]['Department'],
        "FromDate": this.From,
        "ToDate": this.to,
      }
    }
    sessionStorage.setItem("adminlocation", this.locations);
    sessionStorage.setItem("filterloc", this.location);
    sessionStorage.setItem("Form", this.From);
    sessionStorage.setItem("To", this.to);
    sessionStorage.setItem("Typefilter", this.type);
    sessionStorage.setItem("depart", datafn[i]['Department']);
    this.globalservice.enableloader();
    this.globalservice.ODFilter(filt).subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.allfilter = responsedata['Data'];
        this.router.navigate(['dashboard/ODuser_Filter']);
      }
      var page = sessionStorage.page;
      delete sessionStorage.page;

    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
  lastdata = [
    { value: '1', viewValue: 'Today' },
    { value: '2', viewValue: 'This Week' },
    { value: '3', viewValue: 'This Month' },
    { value: '4', viewValue: 'Range' }
  ]
  getToday(): string {
    return new Date().toISOString().split('T')[0]
 }


//


//

}
